module.exports = __webpack_public_path__ + "img/express.3ded06f5.svg";